import MainLayout from "@/components/layout/applicant/MainLayout.vue";
import {
    required,
    minLength,
    sameAs
} from "vuelidate/lib/validators";
import axios from "axios";

export default {
    name: "applicantResetPassword",
    components: {
        MainLayout
    },

    data() {
        return {
            password: this.password,
            password_confirmation: this.password_confirmation,
            token: this.$route.query.token,
            submitted: false
        };
    },

    validations: {
        password: {
            required,
            minLength: minLength(6)
        },
        password_confirmation: {
            required,
            sameAsPassword: sameAs("password")
        }
    },

    methods: {
        handleSubmit() {
            this.submitted = true;
            if (this.$v.$invalid) {
                return;
            }
            this.checkToken();
        },

        checkToken() {
            var request = {
                password: this.password,
                token: this.token
            };
            axios.post('/applicant/check_token', request)
                .then(response => {
                    if (response.data.token_expired || response.data.no_token) {
                        this.$router.push('/expired_token', () => {});
                    } else if (response.data.success) {
                        if (this.submitted) {
                            this.resetPassword();
                        }
                    }
                })
                .catch(error => {
                    this.$notification.error("လုပ်ဆောင်ချက်မအောင်မြင်ပါ။", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                    console.log("Password Reset Client Error", error);
                });
        },

        resetPassword() {
            var request = {
                password: this.password,
                token: this.token
            };
            axios.post('/applicant/reset_password', request)
                .then(() => {
                    this.$notification.success('စကားဝှက်ပြန်လည်သတ်မှတ်ခြင်း အောင်မြင်ပါသည်။', {
                        timer: 3,
                        position: 'bottomCenter'
                    });
                    this.$router.push({
                        name: "applicantLogin"
                    });
                })
                .catch(error => {
                    this.$notification.error("လုပ်ဆောင်ချက်မအောင်မြင်ပါ။", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                    console.log("Password Reset Client Error", error);
                });
        }
    }, 

    mounted() {
        this.checkToken();
    }
};